import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/AIGC/图1.png'
import _imports_1 from '../assets/img/AIGC/图2.png'


const _withScopeId = n => (_pushScopeId("data-v-18523a35"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aigc" }
const _hoisted_2 = { class: "aigc-banner banner" }
const _hoisted_3 = { class: "warp outer-package" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "b global-title wow animate__bounceInLeft",
  "data-wow-delay": ".1s"
}, "专属可控大模型应用加速平台", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "c global-title wow animate__bounceInRight",
  "data-wow-delay": ".3s"
}, [
  /*#__PURE__*/_createTextVNode("基于IDP基础平台打造，"),
  /*#__PURE__*/_createElementVNode("p", { style: {"height":"14px"} }),
  /*#__PURE__*/_createTextVNode(" 一站式低代码支持大模型微调应用全流程")
], -1))
const _hoisted_6 = {
  class: "d global-title wow animate__bounce",
  "data-wow-duration": "2s"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"aigc-two banner\" data-v-18523a35><div class=\"template outer-package row\" data-v-18523a35><div class=\"left col-5\" data-v-18523a35><p class=\"global-title blue\" data-v-18523a35></p><p class=\"global-title black wow bounceInUp\" data-wow-duration=\"2s\" data-v-18523a35>高效构建专属可控大模型</p><p class=\"con-txt wow bounceInUp\" data-wow-delay=\".1s\" data-wow-duration=\"2s\" data-v-18523a35>安全可控，基于客户自身数据，构建高可控的领域大模型</p><p class=\"con-txt wow bounceInUp\" data-wow-delay=\".2s\" data-wow-duration=\"2s\" data-v-18523a35>流程加速，低代码一站式完成大模型数据接入、监督微调、反馈强化和模型发布全流程</p><p class=\"con-txt wow bounceInUp\" data-wow-delay=\".3s\" data-wow-duration=\"2s\" data-v-18523a35>数据驱动持续迭代，连通模型应用反馈数据，实现模型的持续迭代更新</p></div><div class=\"col-2\" data-v-18523a35></div><div class=\"right col-5 wow bounceInRight\" data-wow-duration=\"1s\" data-v-18523a35><img src=\"" + _imports_0 + "\" alt=\"\" data-v-18523a35></div></div><div class=\"template outer-package row\" data-v-18523a35><div class=\"right col-5 middle wow bounceInLeft\" data-wow-duration=\"1s\" data-v-18523a35><img src=\"" + _imports_1 + "\" style=\"float:left;\" alt=\"\" data-v-18523a35></div><div class=\"col-2\" data-v-18523a35></div><div class=\"left col-5\" data-v-18523a35><p class=\"global-title blue\" data-v-18523a35></p><p class=\"global-title black wow bounceInUp\" data-wow-duration=\"2s\" data-v-18523a35>高性能实现大模型的训练与推理</p><p class=\"con-txt wow bounceInUp\" data-wow-delay=\".1s\" data-wow-duration=\"2s\" data-v-18523a35>对计算资源和任务进行精细化调度，提升资源利用率，降低成本</p><p class=\"con-txt wow bounceInUp\" data-wow-delay=\".2s\" data-wow-duration=\"2s\" data-v-18523a35>对训练和推理进行性能优化，提升速度和稳定性</p></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SecondFooter = _resolveComponent("SecondFooter")!
  const _component_AIGCModel = _resolveComponent("AIGCModel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeAigcStatus(true))),
            class: "e btn-animation1"
          }, "申请试用")
        ])
      ])
    ]),
    _hoisted_7,
    _createVNode(_component_SecondFooter, {
      txt: "构建专属自有可控大模型",
      changeAigcStatus: _ctx.changeAigcStatus,
      isAigc: false
    }, null, 8, ["changeAigcStatus"]),
    (_ctx.aigcmodelVis)
      ? (_openBlock(), _createBlock(_component_AIGCModel, {
          key: 0,
          changeAigcStatus: _ctx.changeAigcStatus
        }, null, 8, ["changeAigcStatus"]))
      : _createCommentVNode("", true)
  ]))
}